module.exports = __webpack_public_path__ + "img/bg-product-5.06271000.png";